import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import i18n from 'i18n-js';
import { Grid, Typography } from '@mui/material';
import { BaseModal } from 'components/UI';
import { Formik, Form, Field } from 'formik';
import { AuthActions } from 'state/modules/auth';
import { TextField } from 'components/FormFields';
import { useDispatch, useSelector } from 'react-redux';

const ChangeEmailModal = ({ open, user, handleClick }) => {
  const formSchema = Yup.object().shape({
    new_email: Yup.string()
      .email(i18n.t('common.invalid_email'))
      .required(i18n.t('common.required_field')),
    password: user?.ciam_id ? Yup.string() : Yup.string().required(i18n.t('common.required_field')),
  });

  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { fetchingUpdateAccount } = useSelector((state) => state.auth);

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      loading={fetchingUpdateAccount}
      title={i18n.t('account.change_email')}
      enterButtonLabel={i18n.t('account.change_email')}
    >
      <Formik
        innerRef={formRef}
        initialValues={{
          new_email: user.email || '',
          password: '',
        }}
        onSubmit={(values) => {
          dispatch(
            AuthActions.fetchUpdateAccount(values, 'email', handleClick, {
              type: 'info',
              message: 'account.change_email_success',
            })
          );
        }}
        validationSchema={formSchema}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Grid data-cy="change-email-modal" container spacing={2}>
              {user?.ciam_id && (
                <Grid data-cy="change-email-remove-mfa" size={{ xs: 12 }}>
                  <Typography
                    sx={(muiTheme) => ({
                      fontSize: '13px',
                      color: muiTheme.palette.secondary.dark,
                      fontWeight: 300,
                      mt: 0.5,
                      wordBreak: 'break-word',
                    })}
                  >
                    {i18n.t('account.change_email_remove_mfa')}
                  </Typography>
                </Grid>
              )}
              <Grid size={{ xs: 12 }}>
                <Field
                  data-cy="email-input"
                  type="email"
                  margin="none"
                  name="new_email"
                  component={TextField}
                  label={i18n.t('account.new_email')}
                />
              </Grid>
              {!user?.ciam_id && (
                <Grid size={{ xs: 12 }}>
                  <Field
                    data-cy="password-input"
                    type="password"
                    name="password"
                    component={TextField}
                    label={i18n.t('account.password')}
                  />
                </Grid>
              )}
            </Grid>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

ChangeEmailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  user: PropTypes.shape({
    ciam_id: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
};

ChangeEmailModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangeEmailModal;
